import React from 'react'
import {
  FieldError,
  Label,
  Text,
  TextArea as AriaTextArea,
  TextField as AriaTextField,
  TextFieldProps as AriaTextFieldProps,
  ValidationResult,
} from 'react-aria-components'

export interface TextFieldProps extends AriaTextFieldProps {
  label?: React.ReactNode
  description?: string
  errorMessage?: string | ((validation: ValidationResult) => string)
}

export function Textarea({ label, description, errorMessage, ...props }: TextFieldProps) {
  return (
    <AriaTextField {...props}>
      <Label>{label}</Label>
      <AriaTextArea />
      {description && <Text slot="description">{description}</Text>}
      <FieldError>{errorMessage}</FieldError>
    </AriaTextField>
  )
}
